import { render, staticRenderFns } from "./viewRule.vue?vue&type=template&id=09ab9580&scoped=true"
import script from "./viewRule.vue?vue&type=script&lang=js"
export * from "./viewRule.vue?vue&type=script&lang=js"
import style0 from "./viewRule.vue?vue&type=style&index=0&id=09ab9580&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab9580",
  null
  
)

export default component.exports